/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React,{useCallback,useEffect,useState, useContext} from 'react'
import { motion } from 'framer-motion'
import ReactModal from 'react-modal'
import { connect } from 'react-redux'
import { Link, useLocation, useParams } from 'react-router-dom'
import OrderSummary from '../../../Components/OrderSummary'
import OrderEubSummary from '../../../Components/OrderSummary/OrderEubSummary'
import OrderNormalSummary from '../../../Components/OrderSummary/OrderNormalSummary'
import { DistributorActions } from '../../../redux/actions'
import { GenerateDateFormat, generateDateWithTime } from '../../../redux/helper/DateConverter'
import { distributorService } from '../../../service/distributor.service'
import AcceptReject from '../AcceptReject'
import moment from 'moment'
import Success from '../../../Components/OrderSuccess'
import HeaderContext from '../../../Components/Context/HeaderContext'
import { WishlistedProduct } from '../../../redux/helper/AddWishlist'
import OrderHeader from './Components/OrderHeader'
import RevisedSummary from '../../../Components/OrderSummary/RevisedSummary'
import ClearCart from '../../OfferDetails/ClearCart'
import uuid from 'react-uuid'
import ViewOrderSkeleton from './viewOrderSkeleton'
import DirectOrderSummary from './Components/DirectOrderSummary'
import OrderInvoices from './Components/OrderInvoices'
import EmptyOrderPage from '../EmptyOrderPage'

function ViewOrder({OrderData,GetOrderDetails,cartList,Profile,Getprofile,GetCalculation,Calculation}) {
    const [invoiceDetails, setInvoiceDetails] = useState({});
    const [wishProducts, setwishProducts] = useState([]);
    const [GroupCategoryValue, setGroupCategoryValue] = useState('');

    const handlewish=async()=>{
        const list= await WishlistedProduct();
        setwishProducts(list)
    }
    const [addressDropdown, setaddressDropdown] = useState({});
    const [removePopup, setremovePopup] = useState('');
    const [removeLoader, setremoveLoader] = useState(false)
    const location = useLocation()
    const {id}=useParams();

    const [document, setdocument] = useState({
        instruction:'',
        PO_details:'',
        attach_po:[],
        attach_file:[]
    })
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);

    const [loading, setloading] = useState(true);
    const [statusloader, setstatusloader] = useState(false)
    const [acceptRejectPopup, setacceptRejectPopup] = useState('');
    const [orderSuccess, setorderSuccess] = useState([]);
    const [adorCashCheck, setadorCashCheck] = useState(false);
    const [orderFlow, setorderFlow] = useState({
        order_type:''
    })
    const [shimmerLoading, setShimmerLoading] = useState(true);
    const [YesUpdate, setYesUpdate] = useState(false);
    const [tabToggle, setTabToggle] = useState('products');

    const DISTRIBUTOR = JSON.parse(localStorage.getItem('user')).profile;


    const handleFetch=useCallback(
        () => {
            GetOrderDetails(id).then((res)=>{
                Getprofile();
                GetCalculation()
                setorderFlow({
                    order_type:res.data.data.order_type
                })
                if(!res.error){
                    setdocument({
                        instruction:res?.data?.data?.instruction,
                        PO_details:res?.data?.data?.po_number,
                        attach_po:res?.data?.data?.po_document,
                        attach_file:res?.data?.data?.po_additional_document
                    })
                }
                setadorCashCheck(Number(res.data.data.ador_cash_used)>0)
                setloading(false)
                setShimmerLoading(false)
                handlewish();
                getAddresList()
            })
        },
        [id,YesUpdate],
    )

    const handleFetchOrderInvoiceDetails = useCallback(
        async () => {
            const res = await distributorService.OrderInvoiceDetails(id, DISTRIBUTOR.ACCOUNT_NUMBER);
            if (res.data.data.length > 0) {
                setInvoiceDetails(res.data.data);
            }
        },
    );

    useEffect(() => {
        handleFetch()
        handleFetchOrderInvoiceDetails()
    }, [handleFetch])
   
    const [selectedID, setselectedID] = useState('')
    const handleStatusApprove = async(key)=>{
        let body={}
        if(acceptRejectPopup===''){
            body.instruction=document.instruction,
            body.po_number=document.PO_details,
            body.po_document=document.attach_po,
            body.po_additional_document=document.po_additional_document||[]
        }
        else{
            body={
                status:acceptRejectPopup==='Accept'?'2':'8'
            }
            if(OrderData.order.work_flow_status === "3"){
                let payloadKeys = {};
                const user = JSON.parse(localStorage.getItem('user')).profile;
                body['approvals'] = {
                    approved_time: moment().unix(),
                    approver: 'distributor',
                    note: acceptRejectPopup==='Accept'?'Approved':'Rejected',
                    status : acceptRejectPopup==='Accept'?1:2,
                };
            }else{
                body.instruction=document.instruction,
                body.po_number='',
                body.attach_po=document.po_document,
                body.attach_file=document.po_additional_document
                body['ador_cash_used']=adorCashCheck?OrderData.order.order_type==='Trade'?OrderData.order.summary.order_avail_ador_cash:OrderData.order.summary.proposed_avail_ador_cash: "0"


            }            
        }
        const res = await distributorService.AcceptOrRejectDraftOrder(body,OrderData.order.order_number);
        if(!res.error && res.data.success_status){
            if(body.status==="1"){
                setorderSuccess([OrderData.order.order_initial_number]);

            }else{
                SetSuccessMessage(res?.data?.message);
                setTimeout(() => {
                    SetSuccessMessage('');
                    setcolorValue(false);    
                }, 1000);  
            }
            setacceptRejectPopup('')
            setstatusloader(false);
            setloading(true)
            handleFetch()
        }else{
            SetErrorMessage(res?.message.message ||'Something went wrong');
            setcolorValue(true)
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);    
            }, 1000);        }
        setstatusloader(false)
        
    }
    const orderStatus={
        0 :"Draft",
        1 :"Pending",
        2 :"InProcess",
        3 :"Approved",
        4 :"Out for delivery",
        5 :"partially delivered",
        6 :"deliverd",
        7 :"completed",
        8: "cancelled",
        9:'cancelled'
    }
    const handleAddBulkProducts = async(key)=>{
        let exist =false;
        if(key===undefined){
            const cartItems = await distributorService.CartItems();
            if(!cartItems.error && cartItems.data.data.cart_items.length>0){
                exist=true;
                setremovePopup('active')

            }else{
                exist=false
            }
        }
        const payload =Object.values(OrderData.order.items);
        const finalPayload = []
        payload.forEach(element => {
            finalPayload.push(...element)
        });
        if(exist=== false){
            distributorService.BulkAddProducts(finalPayload).then((res)=>{
                if(!res.error && res.data.success_status){                                        {/* OrderData?.order?.status == "7" || OrderData?.order?.status == "8" && */}

                    SetSuccessMessage(res?.data?.message);
                    setTimeout(() => {
                        SetSuccessMessage('');
                        setcolorValue(false);    
                    }, 1000); 
                    location('/cart');
                }
            })
        }
      
    }
    const handleClearCart=async()=>{
        const cart = await distributorService.clearCart();
        if(!cart.error && cart.data.success_status){
            cartList();
            setremovePopup('');
            handleAddBulkProducts('key')

        }

    }  
    const handleSuccessMessage=(message)=>{
        SetSuccessMessage(message);
        setTimeout(() => {
            SetSuccessMessage('');
            setcolorValue(false);    
        }, 1000); 
    }
    const handleErrorMessage=(message)=>{
        SetErrorMessage(res?.message.message ||'Something went wrong');
        setcolorValue(true)
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);    
        }, 1000);  
    }
    const handleUpdateAddress = async (body, distributor_id, order_no) => {
        const response = await distributorService.UpdateAddress(body, order_no);
        if (!response.error && response.data.success_status) {
            handleSuccessMessage(response.data.message);
            setYesUpdate(!YesUpdate);
        } else {
            handleErrorMessage(response.data.message);
        }
        return response;
    };
    const handleshipbilladdress = (addressList) => {
        const shipping_address = [];
        const billing_address = [];
        if (addressList.length > 0) {
            addressList.map((item, i) => {
                const unique_id = uuid();

                if (item.SITE_USE_CODE === 'BILL_TO') {
                    item.unique_id = `${unique_id}-${i}`;
                    billing_address.push(item);
                } else {
                    item.unique_id = `${unique_id}-${i}`;
                    shipping_address.push(item);
                }
            });
        }
        setaddressDropdown({
            shipping_address,
            billing_address,
        });
        return {
            shipping_address, billing_address,
        };
    };
    const getAddresList = (id) => {
        distributorService.Getprofile(id).then((res) => {
            if (!res.error && res.data.success_status) {
                // setdistributorDetails(res?.data?.data);
                const addr = handleshipbilladdress(res?.data?.data?.SHIP_AND_BILL_ADDRESSES);
            }
        });
    };
    const getItemCount = () => {
        let count = 0;
        OrderData?.order?.items && Object.keys(OrderData?.order?.items).map((item) => {
            count += OrderData?.order.items[item].length;
        });
        return count;
    };
    const reorderStatus=['7','8','3']
    return (
        <div>
            {shimmerLoading && (
                <>
                    <ViewOrderSkeleton/>
                </>
            )}
            <>
                {!shimmerLoading &&
                <div className='md:px-[46px] px-4 pt-2 mb-7'>
                    <ReactModal style={{overFlow:'auto'}} isOpen={removePopup!==''}>
                        <ClearCart
                            setremovePopup={setremovePopup}
                            handleClearCart={handleClearCart}
                            handleAddBulkProducts={handleAddBulkProducts}
                            loading={removeLoader}
                            setremoveLoader={setremoveLoader}/>
                    </ReactModal>
                    {!loading &&<>{
                        OrderData?.order?.status==='0' ?
                        //Draft Order section
                            <div className="flex lg:flex-row flex-col">
                                <div className="w-full">
                                    <div className="flex items-center lg:w-[70%] w-full">
                                        <Link to="/orders">
                                            <img src="/images/arrow-back-fill.svg" alt="icon" />
                                        </Link>
                                        <p className="flex flex-col ml-6">
                                            <span className="md:text-xs10 sm:text-xl text-lg font-semibold text-[#090406]">View {OrderData?.order?.order_type} Order</span>
                                        </p>
                                    </div>
                                    <div className="flex items-center border-b border-[#D3D3D3] pb-3 mt-7">
                                        <div>
                                            <p className="font-semibold text-base text-[#090406]">Order Number</p>
                                            <p className="font-normaltext-l text-[#090406]">{OrderData?.order?.order_initial_number}</p>
                                        </div>
                                        <div className="ml-[66px]">
                                            <p className="font-semibold text-base text-[#090406]">Order Created</p>
                                            <p className="font-normaltext-l text-[#090406]">{generateDateWithTime(OrderData?.order?.created_at)}</p>
                                        </div>
                                        <div className='pl-2 cursor-pointer' onClick={()=>handleAddBulkProducts()}>
                                            <img src="/images/re-order.png" className='cursor-poniter' style={{width:'100%',height:'32px',ObjectFit:'cover'}} />
                                        </div>
                                    </div>
                                    <h5 className="text-xs6 font-semibold text-[#090406] pt-2">
                                        Products(
                                        {getItemCount()}
                                        )
                                    </h5>
                                    {OrderData?.order?.items && Object.values(OrderData?.order?.items).map((item, i) => (
                                        <div className="rounded-[12px] px-1 bg-[#F5F5FA] pt-3 mt-2.5 pb-3" key={i}>
                                            <div className="px-3.5 flex justify-between">
                                                <div className="flex items-center">
                                                    <p className="text-xs3 font-semibold text-[#090406]">
                                                        Products(
                                                        {item.length}
                                                        )
                                                    </p>
                                                    <p className="px-2 py-0.5 text-xs3 font-semibold text-[#FFFFFF] bg-[#44445E] rounded-[2px] ml-5">{Object.keys(OrderData?.order?.items)[i]}</p>
                                                </div>
                                            </div>
                                            {item.map((prod,j) => (
                                                <OrderSummary 
                                                    prod={prod}
                                                    OrderData={OrderData} 
                                                    key={j} 
                                                    wishProducts={wishProducts}
                                                    handleUpdateAddress={handleUpdateAddress}
                                                    addressDropdown={addressDropdown}
                                                    groupIdx={i}
                                                    GroupCategory={GroupCategoryValue}
                                                    setGroupCategoryValue={setGroupCategoryValue}
                                                    GetCartItems={handleFetch}
                                                    Privilages={Profile?.profile?.PRIVILAGES||[]}
                                                    Calculation={Calculation}/>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                                <>{OrderData?.order?.items && Object.keys(OrderData.order.items).length>0 &&(
                                    <>{OrderData?.order?.order_type !=='Trade EUB'?
                                        <OrderNormalSummary 
                                            OrderData={OrderData}
                                            orderFlow={orderFlow}
                                            documentData={document}
                                            setdocument={setdocument}
                                            adorCashCheck={adorCashCheck}
                                            setadorCashCheck={setadorCashCheck}
                                            handleStatusApprove={handleStatusApprove}
                                            setacceptRejectPopup={setacceptRejectPopup}
                                            loader={statusloader}
                                            setloader={setstatusloader}
                                            Privilages={Profile?.profile?.PRIVILAGES||[]}
                                            Calculation={Calculation}
                                        />:
                                        <OrderEubSummary 
                                            OrderData={OrderData}
                                            setacceptRejectPopup={setacceptRejectPopup}
                                            documentData={document}
                                            adorCashCheck={adorCashCheck}
                                            setadorCashCheck={setadorCashCheck}
                                            handleStatusApprove={handleStatusApprove}
                                            loader={statusloader}
                                            setloader={setstatusloader}
                                            setdocument={setdocument}
                                            Privilages={Profile?.profile?.PRIVILAGES||[]}
                                            Calculation={Calculation}/>
                                    }</>
                                )}</>

                            </div>
                            :
                            <div className="w-full">
                                <div className="flex items-center lg:w-[70%] w-full">
                                    <Link to="/orders">
                                        <img src="/images/arrow-back-fill.svg" alt="icon" />
                                    </Link>
                                    <p className="flex flex-col ml-6">
                                        <span className="md:text-xs10 sm:text-xl text-lg font-semibold text-[#090406]">Back to My Orders</span>
                                    </p>
                                </div>
                                <div >
                                    <p className="font-normal text-[#777777] text-sm mt-3 mb-1">Order Number</p>
                                    <div className='flex pb-2 jutify-center items-center'>
                                        <p className="text-[#090406] font-semibold sm:text-xs24 text-base">{OrderData?.order?.order_initial_number}</p>
                                        {reorderStatus.includes(OrderData?.order?.status) &&
                                        <div className='pl-2 cursor-pointer' onClick={()=>handleAddBulkProducts()}>
                                            <img src="/images/re-order.png" className='cursor-poniter' style={{width:'100%',height:'32px',ObjectFit:'cover'}} />

                                        </div>} 
                                        {OrderData?.order?.order_from && 
                                        <div className='pl-[10px]'>                                   
                                            <motion.div
                                                initial={{ opacity: 0, scale: 0.5 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{
                                                    duration: 0.8,
                                                    delay: 0.5,
                                                    ease: [0, 0.71, 0.2, 1.01]
                                                }}  type="button" className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit">{OrderData?.order?.order_from}
                                            </motion.div> 
                                        </div>    
                                        }                
                                        {OrderData?.order?.subscription_id !== null && 
                                        <div className='pl-[10px]'>                                   
                                            <motion.div
                                                initial={{ opacity: 0, scale: 0.5 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{
                                                    duration: 0.8,
                                                    delay: 0.5,
                                                    ease: [0, 0.71, 0.2, 1.01]
                                                }}  type="button" className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit">Bulk
                                            </motion.div> 
                                        </div>    
                                        }                            
                                    </div>
                                </div>
                           
                                <div className="flex w-full xl:flex-nowrap flex-wrap">
                                    <div className="xl:w-[70%] w-full sidebar mt-6xl:w-[30%] w-full lg:mt-0 mt-4 lg:ml-[26px]">
                                        <OrderHeader orderStatus={orderStatus} OrderData={OrderData}/>
                                        {/* <h5 className="text-xs6 font-semibold text-[#090406] pt-2">
                                            Products(
                                            {getItemCount()}
                                            )
                                        </h5> */}
                                        <ul className="nav nav-pills flex flex-row list-none pl-0 mb-4 mt-5 =" id="pills-tab" role="tablist">
                                            <li onClick={() => setTabToggle('products')} className="nav-item mr-[70px]" role="presentation">
                                                <a href="javascript:void(0)" className={`nav-link block ${tabToggle === 'products' ? 'active' : ''} font-semibold text-xs25 text-[#707070] invoices relative`} id="pills-home1-tab" data-bs-toggle="pill" data-bs-target="#pills-home1" role="tab" aria-controls="pills-home1" aria-selected="true">
                                                    Products(
                                                    {getItemCount()}
                                                    )
                                                </a>
                                            </li>
                                            <li onClick={() => setTabToggle('invoices')} className="nav-item" role="presentation">
                                                <a href="javascript:void(0)" className={`nav-link invoices ${tabToggle === 'invoices' ? 'active' : ''} font-semibold text-xs25 text-[#707070] relative block`} id="pills-profile1-tab" data-bs-toggle="pill" data-bs-target="#pills-profile1" role="tab" aria-controls="pills-profile1" aria-selected="false">
                                                    {invoiceDetails.length > 0
                                                        ? (
                                                            <div>
                                                                {' '}
                                                                Invoices(
                                                                {invoiceDetails.length}
                                                                )

                                                            </div>
                                                        )
                                                        : (
                                                            <div>
                                                                Invoices(0)
                                                            </div>
                                                        )}

                                                </a>
                                            </li>
                                        </ul>
                                        <div className="tab-content" id="pills-tabContent">
                                            <div className={`tab-pane ${tabToggle === 'products' ? 'show active' : ''} fade`} id="pills-home1" role="tabpanel" aria-labelledby="pills-home1-tab">
                                                <div className="flex lg:flex-row flex-col">
                                                    <div className="w-full">
                                                        <div className="w-full">
                                                            {OrderData?.order?.items && Object.values(OrderData?.order?.items).map((item, i) => (
                                                                <div className="rounded-[12px] px-1 bg-[#F5F5FA] pt-3 mt-2.5 pb-3" key={i}>
                                                                    <div className="px-3.5 flex justify-between">
                                                                        <div className="flex items-center">
                                                                            <p className="text-xs3 font-semibold text-[#090406]">
                                                                                Products(
                                                                                {item.length}
                                                                                )
                                                                            </p>
                                                                            <p className="px-2 py-0.5 text-xs3 font-semibold text-[#FFFFFF] bg-[#44445E] rounded-[2px] ml-5">{Object.keys(OrderData?.order?.items)[i]}</p>
                                                                        </div>
                                                                    </div>
                                                                    {item.map((prod,j) => (
                                                                        <OrderSummary 
                                                                            prod={prod}
                                                                            OrderData={OrderData} 
                                                                            key={j} 
                                                                            wishProducts={wishProducts}
                                                                            handleUpdateAddress={handleUpdateAddress}
                                                                            addressDropdown={addressDropdown}
                                                                            groupIdx={i}
                                                                            GroupCategory={GroupCategoryValue}
                                                                            setGroupCategoryValue={setGroupCategoryValue}
                                                                            GetCartItems={handleFetch}
                                                                            Privilages={Profile?.profile?.PRIVILAGES||[]}
                                                                            Calculation={Calculation}/>
                                                                    ))}
                                                                </div>
                                                            ))}                                 
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`tab-pane ${tabToggle === 'invoices' ? 'show active' : ''} fade`} id="pills-profile1" role="tabpanel" aria-labelledby="pills-profile1-tab">
                                                <div className="">
                                                    <div className="flex lg:flex-row flex-col">
                                                        <div className="w-full">
                                                            {invoiceDetails.length > 0 ? (
                                                                <OrderInvoices 
                                                                    invoiceDetails={invoiceDetails}
                                                                    setInvoiceDetails={setInvoiceDetails} />

                                                            ) : <EmptyOrderPage 
                                                                search="yes" 
                                                                text="no Invoices" 
                                                                all="found"
                                                            />}
                                                                                                  
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                
                                    </div>
                                    <div className='xl:w-[30%] w-full lg:mt-0 mt-4 lg:ml-[26px] xl:mb-0 mb-2.5'>{OrderData?.order?.items && Object.keys(OrderData.order.items).length>0 &&(
                                        <>{ ['Trade EUB', 'Trade'].includes(OrderData?.order?.order_type)?(
                                            OrderData?.order?.order_type !=='Trade EUB'?
                                                <OrderNormalSummary 
                                                    OrderData={OrderData}
                                                    orderFlow={orderFlow}
                                                    documentData={document}
                                                    setdocument={setdocument}
                                                    adorCashCheck={adorCashCheck}
                                                    setadorCashCheck={setadorCashCheck}
                                                    handleStatusApprove={handleStatusApprove}
                                                    setacceptRejectPopup={setacceptRejectPopup}
                                                    loader={statusloader}
                                                    setloader={setstatusloader}
                                                    Privilages={Profile?.profile?.PRIVILAGES||[]}
                                                    Calculation={Calculation}
                                                />:
                                                <>{Number(OrderData.order.work_flow_status)>= 2 ?
                                                    <RevisedSummary
                                                        OrderData={OrderData}
                                                        setacceptRejectPopup={setacceptRejectPopup}
                                                        documentData={document}
                                                        adorCashCheck={adorCashCheck}
                                                        setadorCashCheck={setadorCashCheck}
                                                        handleStatusApprove={handleStatusApprove}
                                                        loader={statusloader}
                                                        setloader={setstatusloader}
                                                        setdocument={setdocument}
                                                        Privilages={Profile?.profile?.PRIVILAGES||[]}
                                                        Calculation={Calculation}
                                                    />
                                                    :
                                                    <OrderEubSummary 
                                                        OrderData={OrderData}
                                                        setacceptRejectPopup={setacceptRejectPopup}
                                                        documentData={document}
                                                        adorCashCheck={adorCashCheck}
                                                        setadorCashCheck={setadorCashCheck}
                                                        handleStatusApprove={handleStatusApprove}
                                                        loader={statusloader}
                                                        setloader={setstatusloader}
                                                        setdocument={setdocument}
                                                        Privilages={Profile?.profile?.PRIVILAGES||[]}
                                                        Calculation={Calculation}/>}</>
                                        ):<DirectOrderSummary OrderDetails={OrderData.order} />}</>
                                    )}</div>
                                </div>
                            </div>
                    }</>}
                    {
                        <><ReactModal style={{overFlow:'auto'}} isOpen={acceptRejectPopup}>
                            <AcceptReject
                                setacceptRejectPopup={setacceptRejectPopup}
                                loading={setstatusloader}
                                setstatusloader={setstatusloader}
                                selectedID={selectedID}
                                setselectedID={setselectedID}
                                orderData={OrderData}
                                handleStatusApprove={handleStatusApprove}
                                acceptRejectPopup={acceptRejectPopup} />
                        </ReactModal><ReactModal style={{overFlow:'auto'}} isOpen={orderSuccess.length > 0}>
                            <Success orderSuccess={orderSuccess} orderFlow={orderFlow} OrderData={OrderData} />
                        </ReactModal></>
                    }</div>
                }
            </>
        </div>
    )
}
const mapStateToProps = (state) => {
    const { OrderData,Profile,Calculation }=state;
    return { OrderData,Profile,Calculation }
};

const mapDispatchToProps = {
    GetOrderDetails:DistributorActions.GetOrderDetails,
    cartList:DistributorActions.GetCartItems,
    Getprofile:DistributorActions.GetprofileData,
    GetCalculation:DistributorActions.GetCartCalculation,


}
export default connect(mapStateToProps, mapDispatchToProps)(ViewOrder)
